
import { store } from '../../store';
import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import update from 'immutability-helper';
import AppActions from '../../app/app_actions';
import { i18n, Utils, domain, domainVal, NumberFormatter, DateFormatter } from 'arm-common';


const EnumBisogniActions = Object.freeze({

    LIST_BISOGNI: 'LIST_BISOGNI',
    INITIALIZED: 'INITIALIZED',

});

module.exports.EnumBisogniActions = EnumBisogniActions;


class BisogniActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[BisogniActions] ";
    }
    get Actions() {

        return EnumBisogniActions;
    }





    getListBisogni() {
        return function (dispatch) {
            return Rest.post('bisogno/listaBisogniPojo', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumBisogniActions.LIST_BISOGNI, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    

};

export default BisogniActions = new BisogniActions;
